import { Box } from "@chakra-ui/react";
import {
  ColorIcon,
  colors,
  customEvent,
  HStack,
  LargeButton,
  LARGEL_BUTTON_TYPE,
  NextLink,
  Spacing,
  VStack,
} from "goi_common";

import { ReactNode } from "react";

function TotalPriceSection({
  name,
  title = "총 비용(선불제상조 기준)",
  subtitle = "조문객 200명 이하",
  price,
  goiCompareSection,
}: {
  name: string;
  title?: string;
  subtitle?: string;
  price: string;
  goiCompareSection?: ReactNode;
}) {
  return (
    <VStack padding="30px 20px 16px" width="100%" margin="0 0 24px">
      <Box className="subtitle_18_b gray800" wordBreak="keep-all" margin="0 0 16px">
        <Box as="h2">{name} 장례 총 예상 비용</Box>
        <span className="caption_12_b">(장례식장, 납골당, 용품, 인력 등 포함시)</span>
      </Box>
      <HStack
        background={colors.gray900}
        borderRadius="10px"
        padding="18px 16px"
        alignItems="center"
        justifyContent="space-between"
      >
        <VStack>
          <div className="button2 white">{title}</div>
          <div className="caption1 gray500">{subtitle}</div>
        </VStack>

        <Box className="subtitle2_b white" marginTop="-2px">
          <span className="head2">{price}</span>원
        </Box>
      </HStack>
      {goiCompareSection}
      <Spacing gap={16} />
      <Box className="body3_m gray900">
        장례 비용은 <span className="button2">장례식장 비용</span>, 장례 서비스 비용, 장지 비용으로
        구성됩니다.
        <br />
        <br />내 상황에 맞는 장례 비용을 한번에 알아보세요.
      </Box>
      <Spacing gap={24} />
      <NextLink href="/match/request/">
        <LargeButton
          className="button"
          buttonType={LARGEL_BUTTON_TYPE.ORANGE}
          height={44}
          borderRadius={5}
          onClick={() => {
            customEvent({
              newGtm: {
                path: "parlor_region",
                trigger_and_target: "CTA_btm_total_price-uv_match_request",
              },
            });
          }}
        >
          <Box marginRight="12px">전체 장례 비용 알아보기</Box>
          <ColorIcon name="arrow_right_small" color={colors.white} width="16px" height="16px" />
        </LargeButton>
      </NextLink>
      <Spacing gap={12} />
      <NextLink href="/match/request/">
        <LargeButton
          className="button"
          buttonType={LARGEL_BUTTON_TYPE.ORANGE_OUTLINED}
          height={44}
          borderRadius={5}
          onClick={() => {
            customEvent({
              newGtm: {
                path: "parlor_region",
                trigger_and_target: "CTA_btm_consult-uv_match_request",
              },
            });
          }}
        >
          <Box marginRight="12px">고이의 전문 장례지도사와 무료 상담하기</Box>
          <ColorIcon name="arrow_right_small" color={colors.white} width="16px" height="16px" />
        </LargeButton>
      </NextLink>
    </VStack>
  );
}

export default TotalPriceSection;
